export const readFile = (file, convertToArrayBuffer = false) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onabort = () => reject('Read Aborted');
    reader.onerror = () => reject(reader.error);
    reader.onload = () => resolve(reader.result);
    if (convertToArrayBuffer) {
      reader.readAsArrayBuffer(file);
    } else {
      reader.readAsDataURL(file);
    }
  });
